import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'summary-start-page',
	templateUrl: './summary-start-page.component.html',
	imports: [TranslatePipe],
})
export class SummaryStartPageComponent {
	year = input<number>();
}
